import { useMessageCommunicationContext } from '../contexts/MessageCommunicationContext';

const useMessageCommunication = () => {
  return useMessageCommunicationContext();
};

export default useMessageCommunication;
